<script setup lang="ts">
import Messages from "@/components/shared/Messages.vue";
import { RouterView } from "vue-router";
</script>

<template>
  <RouterView></RouterView>
  <Messages />
</template>
